export const NAVBAR_HEIGHT = {
  desktop: '80',
  mobile: '50',
}

export const LOGO_WIDTH = {
  desktop: '270',
  laptop: '165',
  tablet: '139',
  mobile: '50',
}

